import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Box,
  Alert,
  CircularProgress
} from '@mui/material';
import { Warning as WarningIcon, Link as LinkIcon } from '@mui/icons-material';

const EnlacePropuestaModal = ({ 
  open, 
  onClose, 
  onConfirm, 
  iniciativaId,
  enlaceActual = '',
  loading = false,
  estadoDestino = 'supervision'
}) => {
  const [enlace, setEnlace] = useState(enlaceActual || '');
  const [error, setError] = useState('');

  useEffect(() => {
    setEnlace(enlaceActual || '');
  }, [enlaceActual]);

  const handleConfirm = () => {
    if (!enlace.trim()) {
      setError('El enlace al documento es obligatorio');
      return;
    }

    // Validar que sea una URL válida
    try {
      new URL(enlace);
      setError('');
      onConfirm(enlace.trim());
    } catch (e) {
      setError('Por favor, introduce una URL válida (debe empezar con http:// o https://)');
    }
  };

  const handleEnlaceChange = (e) => {
    setEnlace(e.target.value);
    if (error) setError('');
  };

  const getEstadoLabel = () => {
    if (estadoDestino === 'supervision') return 'Supervisión';
    if (estadoDestino === 'entregada') return 'Entregada';
    return estadoDestino;
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <WarningIcon color="warning" />
          <Typography variant="h6">
            Enlace al Documento Requerido
          </Typography>
        </Box>
      </DialogTitle>
      
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 3 }}>
          Para cambiar al estado "<strong>{getEstadoLabel()}</strong>" es necesario adjuntar el 
          enlace al documento PPT en SharePoint.
        </Alert>

        <Box sx={{ mt: 2 }}>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
            Por favor, introduce el enlace al documento de la propuesta:
          </Typography>

          <TextField
            fullWidth
            label="Enlace al documento (PPT - SharePoint)"
            value={enlace}
            onChange={handleEnlaceChange}
            error={!!error}
            helperText={error || 'Introduce la URL completa del documento en SharePoint'}
            placeholder="https://sharepoint.com/..."
            disabled={loading}
            variant="outlined"
            InputProps={{
              startAdornment: <LinkIcon sx={{ mr: 1, color: 'text.secondary' }} />
            }}
            sx={{ mb: 2 }}
          />

          {enlaceActual && (
            <Alert severity="info" sx={{ mt: 2 }}>
              <Typography variant="caption">
                <strong>Enlace actual:</strong><br />
                <a href={enlaceActual} target="_blank" rel="noopener noreferrer" style={{ wordBreak: 'break-all' }}>
                  {enlaceActual}
                </a>
              </Typography>
            </Alert>
          )}
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button 
          onClick={onClose} 
          disabled={loading}
          variant="outlined"
        >
          Cancelar
        </Button>
        <Button
          onClick={handleConfirm}
          disabled={loading || !enlace.trim()}
          variant="contained"
          color="primary"
          startIcon={loading && <CircularProgress size={20} />}
        >
          {loading ? 'Guardando...' : 'Guardar y Continuar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EnlacePropuestaModal;
